import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BankOutlined, RightOutlined } from '@ant-design/icons';
import './style.scss';

export default function HotelMemberList({ members }) {
  const pageRef = useRef(null);

  useEffect(() => {
    // Other pages set global container widths; keep this override local to the list.
    const host = pageRef.current.closest('.container');
    if (!host) return undefined;
    host.classList.add('hotel-member-list-host');
    return () => host.classList.remove('hotel-member-list-host');
  }, []);

  return (
    <main className="hotel-member-list" ref={pageRef} aria-labelledby="hotel-member-list-title">
      <header className="hotel-member-list__header">
        <h1 id="hotel-member-list-title">酒店会员礼遇</h1>
        <p>{members.length} 个会员计划</p>
      </header>

      <nav aria-label="酒店会员">
        <ul className="hotel-member-list__items">
          {members.map((member) => (
            <li key={member.path}>
              <Link className="hotel-member-list__link" to={member.path}>
                <span className="hotel-member-list__icon" aria-hidden="true">
                  <BankOutlined />
                </span>
                <span className="hotel-member-list__name">{member.title}</span>
                <RightOutlined className="hotel-member-list__arrow" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </main>
  );
}
